import { Linkedin } from "lucide-react";

const PORTRAIT_URL =
  "https://customer-assets.emergentagent.com/job_ask-anthony/artifacts/5ov685ls_pro-gZ3bX1xw.jpeg";

const SUBSCRIBE_URL =
  "https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7314551039267856384";

export default function Hero() {
  return (
    <section className="relative">
      <div className="flex flex-col items-start gap-6">
        <div className="flex items-center gap-4">
          <div className="relative inline-flex">
            <img
              src={PORTRAIT_URL}
              alt="Anthony Magee"
              className="h-20 w-20 sm:h-24 sm:w-24 rounded-full object-cover ring-2 ring-[rgba(244,236,224,0.55)] shadow-[0_14px_40px_rgba(0,0,0,0.45)]"
              data-testid="hero-portrait"
              loading="eager"
            />
            <span className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full bg-[#FF4FA3] ring-2 ring-[#4A0B1E]" />
          </div>
          <div>
            <p
              className="text-xs sm:text-sm uppercase tracking-[0.22em] text-[rgba(244,236,224,0.78)]"
              data-testid="hero-eyebrow"
            >
              Anthony Magee
            </p>
            <p className="text-sm text-[rgba(244,236,224,0.7)]">
              AI strategist · data geek · UK
            </p>
          </div>
        </div>

        <h1
          className="font-display font-extrabold tracking-[-0.03em] leading-[0.96] text-[clamp(2.5rem,7vw,5rem)] text-[#F4ECE0]"
          data-testid="hero-masthead"
        >
          Looking Back,
          <br />
          Thinking Forward
        </h1>

        <p
          className="max-w-2xl text-base sm:text-lg text-[rgba(244,236,224,0.92)] font-medium"
          data-testid="hero-tagline"
        >
          AI, Ethics &amp; Big Ideas Weekly. Honest takes on inclusive AI,
          neurodivergence, bias and the awkward questions nobody else is asking.
        </p>

        <p
          className="text-sm sm:text-base text-[rgba(244,236,224,0.82)]"
          data-testid="hero-social-proof"
        >
          Join 400+ curious thinkers.
        </p>

        <a
          href={SUBSCRIBE_URL}
          target="_blank"
          rel="noreferrer"
          aria-label="Subscribe free to Looking Back, Thinking Forward on LinkedIn"
          data-testid="linkedin-subscribe-pill"
          className="group inline-flex items-center gap-3 rounded-full bg-[#0E0B0D] text-[#F4ECE0] pl-2 pr-5 py-2 text-sm sm:text-base font-semibold shadow-[0_10px_24px_rgba(0,0,0,0.32)] hover:bg-[#171114] hover:shadow-[0_14px_34px_rgba(0,0,0,0.4)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(244,236,224,0.55)] focus-visible:ring-offset-2 focus-visible:ring-offset-transparent active:scale-[0.98] transition-[background-color,box-shadow,transform] duration-200"
        >
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-[#0A66C2] text-white">
            <Linkedin className="h-4 w-4" strokeWidth={2.4} />
          </span>
          Subscribe Free
          <span className="text-[rgba(244,236,224,0.55)] text-xs hidden sm:inline">
            · on LinkedIn
          </span>
        </a>
      </div>
    </section>
  );
}
